import { FaCalendar, FaChartPie } from "react-icons/fa";
// import { FaCalendar, FaChartPie } from "react-icons/fa";
import { FiTrendingUp, FiTrendingDown, FiRefreshCcw } from "react-icons/fi";
import { FcAcceptDatabase } from "react-icons/fc";
import { MdPendingActions } from "react-icons/md";
import { GiProgression } from "react-icons/gi";
import { MdRequestQuote } from "react-icons/md";
import { BsPersonUp } from "react-icons/bs";
import { FaPoundSign } from "react-icons/fa";
import { HiStatusOnline } from "react-icons/hi";
import { BiSolidUserDetail } from "react-icons/bi";
import { FaRegCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { MetricCard } from "../../components/AnalyticsComponents/metricCard";
import PopularServicesList from "../../components/AnalyticsComponents/popularServices";
import { RevenueChart } from "../../components/AnalyticsComponents/revenueChart";
import "./style.css";
import PeakBookingHours from "../../components/AnalyticsComponents/peakBookingHours";
import { ApiCaller } from '../../config';
import { TextField } from '../../components'
import { useEffect, useState } from "react";
import { MdAnalytics } from "react-icons/md";
import StatusBreakdownCard from "../../components/AnalyticsComponents/statusBreakdownCard";
import { BookingChart } from "../../components/AnalyticsComponents/bookingsChart";
import CommissionChart from "../../components/AnalyticsComponents/commissionChart";
import BookingBarChart from "../../components/AnalyticsComponents/bookingBarChart";
import { AiFillDatabase } from "react-icons/ai";
import { useQuery, useQueryClient } from "react-query";
import { Tag } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import PerformanceComparison from "../../components/AnalyticsComponents/statsGird";


const rangeFilters = [
    {
        label: "Today",
        value: "daily",
    },
    {
        label: "This Week",
        value: "weekly",
    },
    {
        label: "This Month",
        value: "monthly",
    },
    {
        label: "This Year",
        value: "yearly",
    }
]

const delayTimer = 300000;
// 1800000; // 30 min
// 60000 1 min

// api calls.
const fetchDashboardAnalytics = async (filters) => (await ApiCaller.Get(`/admin/dashboard/analytics?dateRange=${filters.dateRange}&type=${filters.type}`))?.data;
const fetchBookingsByStatus = async (filters) => (await ApiCaller.Get(`/admin/dashboard/bookings-by-status?dateRange=${filters.dateRange}&type=${filters.type}`))
const fetchPerformanceComparison = async (filters) => (await ApiCaller.Get(`/admin/dashboard/performance-comparison?type=${filters.type}`))
const fetchPeakBookingHours = async (filters) => (await ApiCaller.Get(`/admin/dashboard/peak-booking-hours?type=${filters.type}`))
const fetchServices = async (filters) => (await ApiCaller.Get(`/admin/dashboard/most-popular-services?type=${filters.type}`))
const fetchRevenueDistribution = async (filters) => (await ApiCaller.Get(`/admin/dashboard/revenue-distribution?dateRange=${filters.dateRange}`))

const SpAndUserAnalysis = () => {

    const [spDashboardAnalyticsFilters, setSpDashboardAnalyticsFilters] = useState({
        dateRange: 'daily',
        type: 'Service Provider'
    })
    const [suDashboardAnalyticsFilters, setSuDashboardAnalyticsFilters] = useState({
        dateRange: 'daily',
        type: 'Service User'
    })
    const [spBookingsByStatusFilters, setSpBookingsByStatusFilters] = useState({
        dateRange: 'daily',
        type: 'Service Provider'
    })
    const [suBookingsByStatusFilters, setSuBookingsByStatusFilters] = useState({
        dateRange: 'daily',
        type: 'Service User'
    })
    const [spPerformanceComparisonFilters, setSpPerformanceComparisonFilters] = useState({
        type: 'Service Provider'
    })
    const [suPerformanceComparisonFilters, setSuPerformanceComparisonFilters] = useState({
        type: 'Service User'
    })
    const [spPeakBookingHoursFilters, setSpPeakBookingHoursFilters] = useState({
        type: 'Service Provider'
    })
    const [suPeakBookingHoursFilters, setSuPeakBookingHoursFilters] = useState({
        type: 'Service User'
    })
    const [spSevicesFilters, setSpSevicesFilters] = useState({
        type: 'Service Provider'
    })
    const [suSevicesFilters, setSuSevicesFilters] = useState({
        type: 'Service User'
    })
    const [spRevenueDistributionFilters, setSpRevenueDistributionFilters] = useState({
        dateRange: 'daily'
    })

    const queryClient = useQueryClient();
    const [timer, setTimer] = useState(300); // 5 minutes in seconds

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer === 0) {
                    queryClient.invalidateQueries();
                    return 300;
                }
                return prevTimer - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [queryClient]);

    const handleRefresh = () => {
        setTimer(300);
        queryClient.invalidateQueries();
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    // query calls
    const spDashboardAnalyticsQuery = useQuery({
        queryKey: ["spDashboardAnalytics", spDashboardAnalyticsFilters],
        queryFn: () => fetchDashboardAnalytics(spDashboardAnalyticsFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const suDashboardAnalyticsQuery = useQuery({
        queryKey: ["suDashboardAnalytics", suDashboardAnalyticsFilters],
        queryFn: () => fetchDashboardAnalytics(suDashboardAnalyticsFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const spBookingsByStatusQuery = useQuery({
        queryKey: ["spBookingsByStatus", spBookingsByStatusFilters],
        queryFn: () => fetchBookingsByStatus(spBookingsByStatusFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const suBookingsByStatusQuery = useQuery({
        queryKey: ["suBookingsByStatus", suBookingsByStatusFilters],
        queryFn: () => fetchBookingsByStatus(suBookingsByStatusFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const spPerformanceComparisonQuery = useQuery({
        queryKey: ["spPerformanceComparison", spPerformanceComparisonFilters],
        queryFn: () => fetchPerformanceComparison(spPerformanceComparisonFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const suPerformanceComparisonQuery = useQuery({
        queryKey: ["suPerformanceComparison", suPerformanceComparisonFilters],
        queryFn: () => fetchPerformanceComparison(suPerformanceComparisonFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const spPeakBookingHoursQuery = useQuery({
        queryKey: ["spPeakBookingHours", spPeakBookingHoursFilters],
        queryFn: () => fetchPeakBookingHours(spPeakBookingHoursFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const suPeakBookingHoursQuery = useQuery({
        queryKey: ["suPeakBookingHours", suPeakBookingHoursFilters],
        queryFn: () => fetchPeakBookingHours(suPeakBookingHoursFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const spServicesQuery = useQuery({
        queryKey: ["spServices", spSevicesFilters],
        queryFn: () => fetchServices(spSevicesFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const suServicesQuery = useQuery({
        queryKey: ["suServices", suSevicesFilters],
        queryFn: () => fetchServices(suSevicesFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })
    const spRevenueDistributionQuery = useQuery({
        queryKey: ["spRevenueDistribution", spRevenueDistributionFilters],
        queryFn: () => fetchRevenueDistribution(spRevenueDistributionFilters),
        onError: (error) => console.log(error),
        refetchInterval: delayTimer // 30 min
    })

    // data variables holding updated values from queries.
    const spDashboardAnalyticsData = spDashboardAnalyticsQuery?.data?.data?.data;
    const suDashboardAnalyticsData = suDashboardAnalyticsQuery?.data?.data?.data;
    const spBookingsByStatusData = spBookingsByStatusQuery?.data?.data?.data;
    const suBookingsByStatusData = suBookingsByStatusQuery?.data?.data?.data;
    const spPerformanceComparisonData = spPerformanceComparisonQuery?.data?.data?.data;
    const suPerformanceComparisonData = suPerformanceComparisonQuery?.data?.data?.data;
    const spPeakBookingData = spPeakBookingHoursQuery?.data?.data?.data;
    const suPeakBookingData = suPeakBookingHoursQuery?.data?.data?.data;
    const spServicesData = spServicesQuery?.data?.data?.data?.data;
    const suServicesData = suServicesQuery?.data?.data?.data?.data;
    const spRevenueDistributionData = spRevenueDistributionQuery?.data?.data?.data;

    const rangeFiltersHandler = (type, value) => {
        switch (type) {
            case 'suAnalyticsDashboard':
                setSuDashboardAnalyticsFilters({ ...suDashboardAnalyticsFilters, dateRange: value })
                break;
            case 'spAnalyticsDashboard':
                setSpDashboardAnalyticsFilters({ ...spDashboardAnalyticsFilters, dateRange: value })
                break;
            case 'spBookingsByStatus':
                setSpBookingsByStatusFilters({ ...spBookingsByStatusFilters, dateRange: value })
                break;
            case 'suBookingsByStatus':
                setSuBookingsByStatusFilters({ ...suBookingsByStatusFilters, dateRange: value })
                break;
            case 'spRevenueDistribution':
                setSpRevenueDistributionFilters({ ...spRevenueDistributionFilters, dateRange: value })
                break;
            default:
                break;
        }
    }

    return (
        <div className="analytics-container">
            {/* Header */}
            <div className="analytics-header">
                <h1 className="analytics-title">Provider and User Analytics</h1>
                <p className="analytics-subtitle">
                    Comprehensive insights into Provider and User engagements
                </p>

            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', marginBottom: '10px' }}>
                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#fab700' }}>
                    The data will refresh in <span style={{ color: '#555' }}>{formatTime(timer)}</span>
                </span>
                <FiRefreshCcw
                    size={20}
                    style={{ cursor: 'pointer', color: '#555' }}
                    onClick={handleRefresh}
                    title="Refresh Data"
                />
            </div>

            <div className="analytics-scroll-container">
            <div className="analytics-grid">

                {/* Service Provider Section ============================================================ */}
                <div className="provider-section">
                    <div className="section-header">
                        <div className="section-divider" />
                        <h2 className="section-title">Service Provider</h2>
                        <div className="section-divider" />
                    </div>

                    {/* Admin Analytics Dashboard */}
                    <div className="metric-section">
                        {
                            spDashboardAnalyticsQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <div className="metric-section-header">
                            <div className="metric-section-info">
                                <MdAnalytics className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Admin Analytics Dashboard</h3>
                            </div>
                            <div>
                                <TextField.SelectField
                                    placeholder="Select"
                                    size="large"
                                    id="provider-management-select"
                                    type="text"
                                    disabled={false}
                                    required={false}
                                    value={spDashboardAnalyticsFilters.dateRange}
                                    label=""
                                    defaultValue="daily"
                                    error={false}
                                    helperText=""
                                    onChange={(value) => rangeFiltersHandler('spAnalyticsDashboard', value)}
                                    data={rangeFilters}
                                />
                            </div>
                        </div>

                        {/* Key Metrics */}
                        <div className="metrics-grid">
                            <MetricCard
                                title="Total Bookings"
                                value={(spDashboardAnalyticsData?.totalBookings?.value) || 0}
                                icon={FaCalendar}
                                variant="primary"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.totalBookings?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.totalBookings?.change}
                            />
                            <MetricCard
                                title="Completions"
                                value={(spDashboardAnalyticsData?.completed?.value) || 0}
                                icon={FiTrendingUp}
                                variant="accent"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.completed?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.completed?.change}
                            />
                            <MetricCard
                                title="Cancellations"
                                value={(spDashboardAnalyticsData?.cancelled?.value) || 0}
                                icon={FiTrendingDown}
                                variant="secondary"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.cancelled?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.cancelled?.change}
                            />
                            <MetricCard
                                title="Pending"
                                value={(spDashboardAnalyticsData?.pending?.value) || 0}
                                icon={MdPendingActions}
                                variant="warning"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.pending?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.pending?.change}
                            />
                            {/* need to discuss */}
                            <MetricCard
                                title="Accepted"
                                value={(spDashboardAnalyticsData?.accepted?.value) || 0}
                                icon={FcAcceptDatabase}
                                variant="success"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.accepted?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.accepted?.change}
                            />
                            <MetricCard
                                title="In-Progress"
                                value={(spDashboardAnalyticsData?.inProgress?.value) || 0}
                                icon={GiProgression}
                                variant="info"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.inProgress?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.inProgress?.change}
                            />
                            <MetricCard
                                title="Direct Bookings"
                                value={(spDashboardAnalyticsData?.directBookings?.value) || 0}
                                icon={MdRequestQuote}
                                variant="warning"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.directBookings?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.directBookings?.change}
                            />
                            <MetricCard
                                title="Quoted Bookings"
                                value={(spDashboardAnalyticsData?.quotedBookings?.value) || 0}
                                icon={MdRequestQuote}
                                variant="success"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.quotedBookings?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.quotedBookings?.change}
                            />
                            <MetricCard
                                title="Revenue (£)"
                                value={spDashboardAnalyticsData?.revenue?.value ? Number(spDashboardAnalyticsData?.revenue?.value)?.toFixed(2) : 0}
                                icon={FaPoundSign}
                                variant="primary"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.revenue?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.revenue?.change}
                            />
                            <MetricCard
                                title="Platform Commission"
                                value={spDashboardAnalyticsData?.platformCommission?.value ? Number(spDashboardAnalyticsData?.platformCommission?.value)?.toFixed(2) : 0}
                                icon={BsPersonUp}
                                variant="info"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.platformCommission?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.platformCommission?.change}
                            />
                            <MetricCard
                                title="Expert Payouts"
                                value={spDashboardAnalyticsData?.expertPayouts?.value ? Number(spDashboardAnalyticsData?.expertPayouts?.value)?.toFixed(2) : 0}
                                icon={FaPoundSign}
                                variant="success"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.expertPayouts?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.expertPayouts?.change}
                            />
                        </div>
                    </div>

                    {/* Revenue Trends */}
                    <div className="revenue-trend-section">
                        {
                            spBookingsByStatusQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <div className="metric-section-header">
                            <div className="metric-section-info">
                                <BiSolidUserDetail className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Bookings By Status</h3>
                            </div>
                            <div>
                                <TextField.SelectField
                                    placeholder="Select"
                                    size="large"
                                    id="provider-management-select"
                                    type="text"
                                    disabled={false}
                                    required={false}
                                    value={spBookingsByStatusFilters.dateRange}
                                    label=""
                                    defaultValue="daily"
                                    error={false}
                                    helperText=""
                                    onChange={(value) => rangeFiltersHandler('spBookingsByStatus', value)}
                                    data={rangeFilters}
                                />
                            </div>
                        </div>

                        {/* Key Metrics */}
                        <div className="revenue-metrics-grid">
                            <MetricCard
                                title="Total Bookings"
                                value={spBookingsByStatusData?.data?.cards?.totalBookings || 0}
                                icon={FaCalendar}
                                variant="primary"
                            />
                            <MetricCard
                                title="Total Revenue (£)"
                                value={spBookingsByStatusData?.data?.cards?.totalRevenue ? Number(spBookingsByStatusData?.data?.cards?.totalRevenue)?.toFixed(2) : 0}
                                icon={FaPoundSign}
                                variant="secondary"
                            />
                            <MetricCard
                                title="Commission"
                                value={spBookingsByStatusData?.data?.cards?.commission || 0}
                                icon={BsPersonUp}
                                variant="info"
                            />
                            <MetricCard
                                title="Expert Payouts"
                                value={spBookingsByStatusData?.data?.cards?.expertPayouts || 0}
                                icon={FaPoundSign}
                                variant="success"
                            />
                            <MetricCard
                                title="Direct Bookings"
                                value={spBookingsByStatusData?.data?.cards?.directBookings || 0}
                                icon={MdRequestQuote}
                                variant="warning"
                            />
                            <MetricCard
                                title="Quoted Bookings"
                                value={spBookingsByStatusData?.data?.cards?.quotedBookings || 0}
                                icon={MdRequestQuote}
                                variant="success"
                            />
                        </div>

                        {/* status breakdown - direct booking */}
                        <div className="status-breakdown-container">
                            <div className="metric-section-info">
                                <HiStatusOnline className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Status Breakdown - Direct Bookings</h3>
                            </div>
                            <div className="metrics-grid">
                                <StatusBreakdownCard
                                    title={'Pending'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.direct?.count || 0}
                                    icon={MdPendingActions}
                                    variant="pending"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.direct?.percentage || 0}
                                    iconColor={'#C88A03'}
                                />
                                <StatusBreakdownCard
                                    title={'In-Progress'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.direct?.count || 0}
                                    icon={GiProgression}
                                    variant="inprogress"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.direct?.percentage || 0}
                                    iconColor={'#2662EB'}
                                />
                                <StatusBreakdownCard
                                    title={'Completed'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.direct?.count || 0}
                                    icon={FaRegCheckCircle}
                                    variant="completed"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.direct?.percentage || 0}
                                    iconColor={'#19A049'}
                                />
                                <StatusBreakdownCard
                                    title={'Cancelled'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.direct?.count || 0}
                                    icon={RxCrossCircled}
                                    variant="cancelled"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.direct?.percentage || 0}
                                    iconColor={'#DC2626'}
                                />
                            </div>
                        </div>

                        {/* status breakdown of quote booking */}
                        <div className="status-breakdown-container">
                            <div className="metric-section-info">
                                <HiStatusOnline className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Status Breakdown - Quote Bookings</h3>
                            </div>
                            <div className="metrics-grid">
                                <StatusBreakdownCard
                                    title={'Pending'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.quoted?.count || 0}
                                    icon={MdPendingActions}
                                    variant="pending"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.quoted?.percentage || 0}
                                    iconColor={'#C88A03'}
                                />
                                <StatusBreakdownCard
                                    title={'In-Progress'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.quoted?.count || 0}
                                    icon={GiProgression}
                                    variant="inprogress"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.quoted?.percentage || 0}
                                    iconColor={'#2662EB'}
                                />
                                <StatusBreakdownCard
                                    title={'Completed'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.quoted?.count || 0}
                                    icon={FaRegCheckCircle}
                                    variant="completed"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.quoted?.percentage || 0}
                                    iconColor={'#19A049'}
                                />
                                <StatusBreakdownCard
                                    title={'Cancelled'}
                                    value={spBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.quoted?.count || 0}
                                    icon={RxCrossCircled}
                                    variant="cancelled"
                                    percent={spBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.quoted?.percentage || 0}
                                    iconColor={'#DC2626'}
                                />
                            </div>
                        </div>

                        <BookingChart
                            data={spBookingsByStatusData?.data?.trends?.bookingsLine}
                            title="Bookings Trends - Line Chart"
                            color="#667eea"
                        />

                        {/* <div> */}
                        <BookingBarChart
                            data={spBookingsByStatusData?.data?.trends?.bookingsBar}
                            title="Revenue Trends"
                        />
                        {/* </div> */}

                        <RevenueChart
                            data={spBookingsByStatusData?.data?.trends?.revenueLine}
                            title="Revenue Trend"
                            color="#08AA73"
                            type="Service Provider"
                        />

                        <div className="total-booking-record-container">
                            <div className="metric-section-info">
                                <AiFillDatabase className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Total Booking Records</h3>
                            </div>
                            <div className="revenue-metrics-grid">
                                <MetricCard
                                    title="Revenue (£)"
                                    value={spBookingsByStatusData?.data?.cards?.lifetimeTotals?.totalRevenue ? Number(spBookingsByStatusData?.data?.cards?.lifetimeTotals?.totalRevenue)?.toFixed(2) : 0}
                                    icon={FaPoundSign}
                                    variant="secondary"
                                />
                                <MetricCard
                                    title="Commission"
                                    value={spBookingsByStatusData?.data?.cards?.lifetimeTotals?.commission ? Number(spBookingsByStatusData?.data?.cards?.lifetimeTotals?.commission)?.toFixed(2) : 0}
                                    icon={BsPersonUp}
                                    variant="info"
                                />
                                <MetricCard
                                    title="Expert Payouts"
                                    value={spBookingsByStatusData?.data?.cards?.lifetimeTotals?.expertPayouts ? Number(spBookingsByStatusData?.data?.cards?.lifetimeTotals?.expertPayouts)?.toFixed(2) : 0}
                                    icon={FaPoundSign}
                                    variant="success"
                                />
                            </div>
                        </div>

                    </div>

                    {/* Performance Stats */}
                    <div className="stats-container">
                        {
                            spPerformanceComparisonQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <PerformanceComparison data={spPerformanceComparisonData?.data} />
                    </div>

                    {/* Peak Booking Hours */}
                    <PeakBookingHours
                        data={spPeakBookingData?.data}
                        title="Peak Booking Hours/Days"
                    />

                    {/* Popular Services */}
                    <PopularServicesList
                        services={spServicesData?.popularServices}
                        title="Most Popular Services"
                    />

                    <div className="commission-chart-section">
                        {
                            spRevenueDistributionQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <div className="chart-card">
                            <div className="chart-header">
                                <div className="chart-header-left">
                                    <FaChartPie className="chart-icon" size={20} />
                                    <h3 className="chart-title">Revenue Distribution</h3>
                                </div>
                                <div>
                                    <TextField.SelectField
                                        placeholder="Select"
                                        size="large"
                                        id="provider-management-select"
                                        type="text"
                                        disabled={false}
                                        required={false}
                                        value={spRevenueDistributionFilters.dateRange}
                                        label=""
                                        defaultValue="daily"
                                        error={false}
                                        helperText=""
                                        onChange={(value) => rangeFiltersHandler('spRevenueDistribution', value)}
                                        data={rangeFilters}
                                    />
                                </div>
                            </div>
                            <CommissionChart
                                platformAmount={spRevenueDistributionData?.data?.distribution?.platformCommission?.amount || 0}
                                expertAmount={spRevenueDistributionData?.data?.distribution?.expertPayouts?.amount || 0}
                                platformCommissionPercentage={spRevenueDistributionData?.data?.distribution?.platformCommission?.percentage || 0}
                                expertCommissionPercentage={spRevenueDistributionData?.data?.distribution?.expertPayouts?.percentage || 0}
                                transactionFeesAmount={spRevenueDistributionData?.data?.distribution?.transactionFees?.amount || 0}
                                transactionFeesPercentage={spRevenueDistributionData?.data?.distribution?.transactionFees?.percentage || 0}
                            />
                        </div>
                    </div>
                </div>

                {/* Vertical Divider */}
                <div className="vertical-divider" />

                {/* Service User Section ================================================================ */}
                <div className="user-section">
                    <div className="section-header">
                        <div className="section-divider" />
                        <h2 className="section-title">Service User</h2>
                        <div className="section-divider" />
                    </div>

                    {/* Admin Analytics Dashboard */}
                    <div className="metric-section">
                        {
                            suDashboardAnalyticsQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <div className="metric-section-header">
                            <div className="metric-section-info">
                                <MdAnalytics className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Admin Analytics Dashboard</h3>
                            </div>
                            <div>
                                <TextField.SelectField
                                    placeholder="Select"
                                    size="large"
                                    id="provider-management-select"
                                    type="text"
                                    disabled={false}
                                    required={false}
                                    value={suDashboardAnalyticsFilters.dateRange}
                                    label=""
                                    defaultValue="daily"
                                    error={false}
                                    helperText=""
                                    onChange={(value) => rangeFiltersHandler('suAnalyticsDashboard', value)}
                                    data={rangeFilters}
                                />
                            </div>
                        </div>

                        {/* Key Metrics */}
                        <div className="metrics-grid">
                            <MetricCard
                                title="Total Bookings"
                                value={(suDashboardAnalyticsData?.totalBookings?.value) || 0}
                                icon={FaCalendar}
                                variant="primary"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.totalBookings?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.totalBookings?.change}
                            />
                            <MetricCard
                                title="Completions"
                                value={(suDashboardAnalyticsData?.completed?.value) || 0}
                                icon={FiTrendingUp}
                                variant="accent"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.completed?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.completed?.change}
                            />
                            <MetricCard
                                title="Cancellations"
                                value={(suDashboardAnalyticsData?.cancelled?.value) || 0}
                                icon={FiTrendingDown}
                                variant="secondary"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.cancelled?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.cancelled?.change}
                            />
                            <MetricCard
                                title="Pending"
                                value={(suDashboardAnalyticsData?.pending?.value) || 0}
                                icon={MdPendingActions}
                                variant="warning"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.pending?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.pending?.change}
                            />
                            {/* need to discuss */}
                            <MetricCard
                                title="Accepted"
                                value={(suDashboardAnalyticsData?.accepted?.value) || 0}
                                icon={FcAcceptDatabase}
                                variant="success"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.accepted?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.accepted?.change}
                            />
                            <MetricCard
                                title="In-Progress"
                                value={(suDashboardAnalyticsData?.inProgress?.value) || 0}
                                icon={GiProgression}
                                variant="info"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.inProgress?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.inProgress?.change}
                            />
                            <MetricCard
                                title="Direct Bookings"
                                value={(suDashboardAnalyticsData?.directBookings?.value) || 0}
                                icon={MdRequestQuote}
                                variant="warning"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.directBookings?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.directBookings?.change}
                            />
                            <MetricCard
                                title="Quoted Bookings"
                                value={(suDashboardAnalyticsData?.quotedBookings?.value) || 0}
                                icon={MdRequestQuote}
                                variant="success"
                                isFooter={true}
                                previousCount={suDashboardAnalyticsData?.quotedBookings?.previous}
                                incrementPercentage={suDashboardAnalyticsData?.quotedBookings?.change}
                            />
                            {/* <MetricCard
                                title="Revenue Today (£)"
                                value={Number(spDashboardAnalyticsData?.revenue?.value)?.toFixed(2) || 0}
                                icon={FaPoundSign}
                                variant="primary"
                                isFooter={true}
                                previousCount={spDashboardAnalyticsData?.revenue?.previous}
                                incrementPercentage={spDashboardAnalyticsData?.revenue?.change}
                            /> */}
                        </div>
                    </div>

                    {/* Revenue Trends */}
                    <div className="revenue-trend-section">
                        {
                            suBookingsByStatusQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <div className="metric-section-header">
                            <div className="metric-section-info">
                                <BiSolidUserDetail className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Bookings By Status</h3>
                            </div>
                            <div>
                                <TextField.SelectField
                                    placeholder="Select"
                                    size="large"
                                    id="provider-management-select"
                                    type="text"
                                    disabled={false}
                                    required={false}
                                    value={suBookingsByStatusFilters.dateRange}
                                    label=""
                                    defaultValue="daily"
                                    error={false}
                                    helperText=""
                                    onChange={(value) => rangeFiltersHandler('suBookingsByStatus', value)}
                                    data={rangeFilters}
                                />
                            </div>
                        </div>

                        {/* Key Metrics */}
                        <div className="revenue-metrics-grid">
                            <MetricCard
                                title="Total Bookings"
                                value={suBookingsByStatusData?.data?.cards?.totalBookings || 0}
                                icon={FaCalendar}
                                variant="primary"
                            />
                            <MetricCard
                                title="Direct Bookings"
                                value={suBookingsByStatusData?.data?.cards?.directBookings || 0}
                                icon={MdRequestQuote}
                                variant="warning"
                            />
                            <MetricCard
                                title="Quoted Bookings"
                                value={suBookingsByStatusData?.data?.cards?.quotedBookings || 0}
                                icon={MdRequestQuote}
                                variant="success"
                            />
                        </div>

                        {/* status breakdown - direct booking */}
                        <div className="status-breakdown-container">
                            <div className="metric-section-info">
                                <HiStatusOnline className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Status Breakdown - Direct Bookings</h3>
                            </div>
                            <div className="metrics-grid">
                                <StatusBreakdownCard
                                    title={'Pending'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.direct?.count || 0}
                                    icon={MdPendingActions}
                                    variant="pending"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.direct?.percentage || 0}
                                    iconColor={'#C88A03'}
                                />
                                <StatusBreakdownCard
                                    title={'In-Progress'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.direct?.count || 0}
                                    icon={GiProgression}
                                    variant="inprogress"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.direct?.percentage || 0}
                                    iconColor={'#2662EB'}
                                />
                                <StatusBreakdownCard
                                    title={'Completed'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.direct?.count || 0}
                                    icon={FaRegCheckCircle}
                                    variant="completed"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.direct?.percentage || 0}
                                    iconColor={'#19A049'}
                                />
                                <StatusBreakdownCard
                                    title={'Cancelled'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.direct?.count || 0}
                                    icon={RxCrossCircled}
                                    variant="cancelled"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.direct?.percentage || 0}
                                    iconColor={'#DC2626'}
                                />
                            </div>
                        </div>

                        {/* status breakdown of quote booking */}
                        <div className="status-breakdown-container">
                            <div className="metric-section-info">
                                <HiStatusOnline className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Status Breakdown - Quote Bookings</h3>
                            </div>
                            <div className="metrics-grid">
                                <StatusBreakdownCard
                                    title={'Pending'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.quoted?.count || 0}
                                    icon={MdPendingActions}
                                    variant="pending"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.pending?.byType?.quoted?.percentage || 0}
                                    iconColor={'#C88A03'}
                                />
                                <StatusBreakdownCard
                                    title={'In-Progress'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.quoted?.count || 0}
                                    icon={GiProgression}
                                    variant="inprogress"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.inProgress?.byType?.quoted?.percentage || 0}
                                    iconColor={'#2662EB'}
                                />
                                <StatusBreakdownCard
                                    title={'Completed'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.quoted?.count || 0}
                                    icon={FaRegCheckCircle}
                                    variant="completed"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.completed?.byType?.quoted?.percentage || 0}
                                    iconColor={'#19A049'}
                                />
                                <StatusBreakdownCard
                                    title={'Cancelled'}
                                    value={suBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.quoted?.count || 0}
                                    icon={RxCrossCircled}
                                    variant="cancelled"
                                    percent={suBookingsByStatusData?.data?.cards?.statusBreakdown?.cancelled?.byType?.quoted?.percentage || 0}
                                    iconColor={'#DC2626'}
                                />
                            </div>
                        </div>

                        <BookingChart
                            data={suBookingsByStatusData?.data?.trends?.bookingsLine}
                            title="Bookings Trends - Line Chart"
                            color="#667eea"
                        />

                        <BookingBarChart
                            data={suBookingsByStatusData?.data?.trends?.bookingsBar}
                            title="Revenue Trends"
                        />

                        <RevenueChart
                            data={suBookingsByStatusData?.data?.trends?.revenueLine}
                            title="Revenue Trend"
                            color="#08AA73"
                            type="Service Provider"
                        />

                        <div className="total-booking-record-container">
                            <div className="metric-section-info">
                                <AiFillDatabase className="chart-icon" style={{ marginTop: '4px' }} size={22} />
                                <h3 className="chart-title">Total Booking Records</h3>
                            </div>
                            <div className="revenue-metrics-grid">
                                <MetricCard
                                    title="Revenue (£)"
                                    value={suBookingsByStatusData?.data?.cards?.lifetimeTotals?.totalRevenue ? Number(suBookingsByStatusData?.data?.cards?.lifetimeTotals?.totalRevenue)?.toFixed(2) : 0}
                                    icon={FaPoundSign}
                                    variant="secondary"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Stats */}
                    <div className="stats-container">
                        {
                            suPerformanceComparisonQuery?.isFetching &&
                            <div className="loading-indicator">
                                <Tag icon={<SyncOutlined spin />} color="warning" style={{ width: 'fit-content' }}>
                                    fetching
                                </Tag>
                            </div>
                        }
                        <PerformanceComparison data={suPerformanceComparisonData?.data} />
                    </div>

                    {/* Peak Booking Hours */}
                    <PeakBookingHours
                        data={suPeakBookingData?.data}
                        title="Peak Booking Hours/Days"
                    />

                    {/* Popular Services */}
                    <PopularServicesList
                        services={suServicesData?.popularServices}
                        title="Most Popular Services"
                    />

                </div>
            </div>
            </div>
        </div >
    );
};

export default SpAndUserAnalysis;
